import { el } from "@dhx/ts-common/dom";
import { Text } from "./Text";

export class Label extends Text {
	toVDOM() {
		const conf = this._config;
		return el(".edit-section.text-edit", { _key: this._uid }, [el(".section-title", conf.label)]);
	}
}
